import axios from 'axios';

export default axios.create({
    baseUrl,
    // in case a token is needed, ex:
    // headers: { "Authorization": "Bearer yourToken" }
});
